import { render } from "./NotFound.vue?vue&type=template&id=556fdcde&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=556fdcde&scoped=true&lang=css"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556fdcde"]])

export default __exports__